import DeleteOutline from '@mui/icons-material/DeleteOutline';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { FC, useState } from 'react';

import { useUpdatePiecesMutation } from '@api/piece';
import { PieceAction } from '@apiContract';
import { tooltips } from '@components/Capture/helper';
import { buildUpdatePiecesRequest } from '@components/MailpieceActions/components/actions/helper';
import { DialogConfirmation } from '@uiKit/DialogConfirmation';

import { showApiErrorToast } from '@utils/apiErrorToast';

import { CaptureId } from '../../types';

type Props = {
  disabled?: boolean;
  onClick: (id: number) => void;
  id?: CaptureId | null;
  onMenuClose?: () => void;
};

const DeleteMenuAction: FC<Props> = ({ disabled, onClick, id, onMenuClose }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [updatePieces, { isLoading: isDeleteLoading }] = useUpdatePiecesMutation();
  return (
    <>
      <MenuItem onClick={() => setIsDialogOpen(true)} disabled={disabled} color="error">
        <ListItemIcon>
          <DeleteOutline color="error" />
        </ListItemIcon>
        <ListItemText sx={{ color: 'error.main' }}>{tooltips.DeleteOutlined}</ListItemText>
      </MenuItem>
      <DialogConfirmation
        maxWidth="xs"
        open={isDialogOpen}
        loading={isDeleteLoading}
        handleClose={() => setIsDialogOpen(false)}
        type="error"
        title="Delete item"
        content={'Are you sure you would like to permanently delete this item?'}
        acceptButtonTitle="Delete"
        acceptButtonHandleClick={async () => {
          if (!id) return;
          const requestData = buildUpdatePiecesRequest({
            mailpieces: [{ id: +id }],
            action: PieceAction.Delete,
          });
          try {
            await updatePieces(requestData).unwrap();
            onClick(+id);
            setIsDialogOpen(false);
            onMenuClose?.();
          } catch (error) {
            showApiErrorToast(error);
          }
        }}
        cancelButtonTitle="Cancel"
        cancelButtonHandleClick={() => setIsDialogOpen(false)}
        darkMode
      />
    </>
  );
};

export default DeleteMenuAction;
